import { create } from 'zustand';

interface Organization {
  id: string;
  name: string;
  ncr_number: string | null;
}

interface Membership {
  org_id: string;
  role: 'owner' | 'admin' | 'analyst' | 'agent' | 'viewer' | 'buyer';
  organization: Organization;
}

interface OrgStore {
  activeOrg: Organization | null;
  activeRole: string | null;
  memberships: Membership[];
  setActiveOrg: (org: Organization | null, role: string | null) => void;
  setMemberships: (memberships: Membership[]) => void;
  switchOrg: (orgId: string) => void;
}

export const useOrgStore = create<OrgStore>((set, get) => ({
  activeOrg: null,
  activeRole: null,
  memberships: [],
  setActiveOrg: (org, role) => set({ activeOrg: org, activeRole: role }),
  setMemberships: (memberships) => {
    set({ memberships });
    // Auto-select first org if none selected
    if (!get().activeOrg && memberships.length > 0) {
      set({ 
        activeOrg: memberships[0].organization,
        activeRole: memberships[0].role
      });
    }
  },
  switchOrg: (orgId) => {
    const membership = get().memberships.find(m => m.org_id === orgId);
    if (membership) {
      set({ 
        activeOrg: membership.organization,
        activeRole: membership.role
      });
    }
  },
}));
